import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

import { AuthProvider } from "./Component/auth/Auth";

import App from "./App";

ReactDOM.render(
  <AuthProvider>
    <App />
  </AuthProvider>,

  document.getElementById("root")
);
